import { useInfiniteQuery, useSuspenseQuery } from "@tanstack/react-query";
import {
  auditLogFilterOptionsQueryOptions,
  auditLogsQueryOptions,
  type FilterOptionsParams,
  type InfiniteAuditLogsParams,
} from "./get-audit-logs";

export const useGetAuditLogs = (params: InfiniteAuditLogsParams) =>
  useInfiniteQuery(auditLogsQueryOptions(params));

export const useGetAuditLogFilterOptions = (params: FilterOptionsParams) =>
  useSuspenseQuery(auditLogFilterOptionsQueryOptions(params));
